import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Col } from "antd";

@inject('store')
@observer
class rooms extends Component {
    render() {
        const { onChangeTime, selectData } = this.props.store.general;
        const selected = {
            color: '#4c84ff'
        };
        return (
            <div className="rooms">
                <Row className="title">客房类数据</Row>
                <Row>
                    <Col span={12}>
                        <div className="total_style title_style">
                            <span>客房数据</span>
                            {/* <div>
                                <span
                                    style={selectData.rooms == 1 ? selected : {}}
                                    onClick={onChangeTime.bind(this, 'rooms', 1)}
                                >本月</span>
                                <span
                                    style={selectData.rooms == 2 ? selected : {}}
                                    onClick={onChangeTime.bind(this, 'rooms', 2)}
                                >本年</span>
                            </div> */}
                        </div>
                        <div id="room_left" style={{ height: 400, width: '100%' }} />
                    </Col>
                    <Col span={12}>
                        <div className="total_style title_style">
                            <span>坪效</span>
                            {/* <div>
                                <span
                                    style={selectData.operating == 1 ? selected : {}}
                                    onClick={onChangeTime.bind(this, 'operating', 1)}
                                >本月</span>
                                <span
                                    style={selectData.operating == 2 ? selected : {}}
                                    onClick={onChangeTime.bind(this, 'operating', 2)}
                                >本年</span>
                            </div> */}
                        </div>
                        <div id="room_right" style={{ height: 400, width: '100%' }} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default rooms;


// WEBPACK FOOTER //
// ./src/components/BI/General/rooms.js